import { useTranslation } from "@next-platform/client-common-core";
import { useCallback } from "react";

import { useToast } from "@/hooks";

/**
 * Shared by the card menu and the profile overlay so both report "less like
 * this" the same way. The rating is fire-and-forget on either path - the
 * Recombee helper swallows its own failures - so this only ever confirms.
 */
export default function useDiscoverLessLikeThisToast(): () => void {
  const { displayToast } = useToast();
  const { t } = useTranslation();

  return useCallback(() => {
    displayToast({ message: t("chatbotCard:dropdown.lessLikeThis.toast.success") });
  }, [displayToast, t]);
}
